import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noValueTextExperiment: {
		id: 'issue-field-number-readview-full.number.no-value-text-experiment',
		defaultMessage: 'Add number',
		description: 'Message when a field has no value',
	},
});
